module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "wrap-container"
  }, [_c('el-col', {
    staticClass: "top-breadcrumb",
    attrs: {
      "span": 24
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_c('b', [_vm._v("首页")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("项目管理")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/project/list'
      }
    }
  }, [_c('b', [_vm._v("项目列表")])]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("项目详情")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', [_c('el-menu', {
    attrs: {
      "default-active": _vm.$route.path,
      "text-color": "#000",
      "active-text-color": "#409EFF"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.deviceCategories), function(item, index) {
    return [_c('el-menu-item', {
      attrs: {
        "index": '/project/detail/' + _vm.$route.params.id + '/' + item.template + '/' + item.deviceCategoryId
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.deviceCategoryName))])])]
  })], 2)], 1), _vm._v(" "), _c('section', {
    staticClass: "router-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e3e09f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/projectDetail.vue
// module id = 1154
// module chunks = 2